/**
 * Retrieves the flag which specifies wether or not this SDK should use a custom header as part of any requests being sent to server.
 * This custom header refers to the current agent version,
 * but it may also contain additional custom information (see customAgentVersionHeaderSuffix).
 * @param {Object} state  The current Redux state object.
 * @return {boolean} True if custom header should be used, false otherwise.
 */
export function injectAgentVersionHeader (state) {
  return state.config.requests.injectAgentVersionHeader
}

/**
 * Retrieves a custom suffix value which specifies any extra information that can be appended to the custom header.
 * This custom header is sent by the SDK, as part of any requests being sent to server.
 * @param {Object} state  The current Redux state object.
 * @return {string} The suffix value.
 */
export function customAgentVersionHeaderSuffix (state) {
  return state.config.requests.customAgentVersionHeaderSuffix
}
